module.exports = __webpack_public_path__ + "static/media/Cooperationbg2@2x.36ed9a66.png";